import { IQuantity, Quantity } from "../../../common/models/quantity.model";

interface IActions {
  openPanelToConfirm: () => void;
  confirmAsAdmin: () => void;
  confirmAsDriver: () => void;
  confirmAsServiceTechnican: () => void;
}

export const generateItems = (quantity: IQuantity, actions: IActions) => {
  switch (quantity) {
    case Quantity.ONE:
      return [
        // {
        //   key: "edit",
        //   text: "Edytuj",
        //   iconProps: { iconName: "edit" },
        //   name: "edit",
        //   onClick: actions.openPanelToConfirm,
        // },
        {
          key: "confirm",
          text: "Zatwierdź",
          iconProps: { iconName: "WaitlistConfirm" },
          name: "edit",
          onClick: actions.openPanelToConfirm,
          subMenuProps: {
            items: [{
              key: "confirmAsAdmin",
              text: "Zatwierdź jako Admin",
              iconProps: { iconName: "Admin" },
              name: "edit",
              onClick: actions.confirmAsAdmin,
            },
            {
              key: "confirmAsDriver",
              text: "Zatwierdź jako Kierowca",
              iconProps: { iconName: "Car" },
              name: "edit",
              onClick: actions.confirmAsDriver,
            },
            {
              key: "confirmAsServiceTechnican",
              text: "Zatwierdź jako Serwisant",
              iconProps: { iconName: "CRMServices" },
              name: "edit",
              onClick: actions.confirmAsServiceTechnican,
            }
            ],
          }
        }
      ];
    default:
      return [];
  }
};